module.exports = __webpack_public_path__ + "static/img/diceng_weixin.0f84a2f4.png";